import { QueryClient } from "@tanstack/react-query";

/**
 * QueryClient configuration for react-query
 * 
 * Default options:
 * - staleTime: 5 minutes - data is considered fresh for 5 minutes
 * - cacheTime: 10 minutes - unused data stays in cache for 10 minutes
 * - retry: 1 - retry failed requests once
 * - refetchOnWindowFocus: false - don't refetch when window regains focus
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
